/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_ApprovedInputs */



/**
* | output |
* | --- |
* | "Approved" |
*
* @param {Editor_Table_Column_ApprovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_approved = /** @type {((inputs?: Editor_Table_Column_ApprovedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_ApprovedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approuve")
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approvato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Одобренный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("得到正式认可的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("承認された")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovado")
	return /** @type {LocalizedString} */ ("Approved")
});